import React, { useState ,useEffect} from 'react';
import { Helmet } from 'react-helmet-async';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector} from 'react-redux';
import { AnnulerReservation } from '../Api/FinalReservationApi';
import db from '../db';
import '../Css/annulation.css';

const Annulation = () => {

    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const [test,setTest] = useState([]);

    let location = useLocation();
    let navigate = useNavigate();
    const { state } = useLocation();

    const { idRestaurant, idReservation } = state;


    useEffect(() => {
        const fetchAndSetData = async()=> {
        try {
          const donner = await db.monTableau.toArray();
          if (donner.length > 0) {
            setTest(donner.find((el) => el.id === parseInt(idRestaurant)));
            console.log("Donner dans dexi=>",donner);
          }
        } catch (error) {
          console.error('Erreur lors de la récupération des données depuis Dexie :', error);
        }
      };
      fetchAndSetData();
      }, [idRestaurant]);

    const reservation = useSelector((state) => state.reservation);

    const client = useSelector((state) => state.client);


    const [annulation, setAnnulation] = useState([
        {
            id: 1,
            name: 'Je souhaite modifier ma réservation',
            libelle: "donner",
            status: false
        },
        {
            id: 2,
            name: 'J’ai choisi un autre restaurant',
            libelle: "donner",
            status: false
        },
        {
            id: 3,
            name: 'Je n’ai pas reçu de confirmation',
            libelle: "donner",
            status: false
        },
        {
            id: 4,
            name: 'J’ai eu le restaurant par téléphone',
            libelle: "donner",
            status: false
        },
        {
            id: 5,
            name: ' Mes convives ont annulée',
            libelle: "donner",
            status: false
        },
        {
            id: 6,
            name: '',
            libelle: "autre",
            status: false
        }
    ]);

    const [errorAutre, setErrorAutre] = useState('');



    const handleChangeStatus = (id) => {
        setAnnulation((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, status: !item.status };
                } else {
                    return { ...item, status: false };
                }
            })
        })
    }

    const handleChange = (e, id) => {
        setAnnulation((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, name: e.target.value }
                } else {
                    return { ...item }
                }
            });
    
        })
    }


    const handleClose = () => {
        setShow(false);
        navigate("/");
    };

    const handleAddAnnulation = () => {
        const statusTrue = annulation.find((el) => el.status === true);
        if (statusTrue) {
            if (statusTrue?.libelle === "autre" && statusTrue?.name === "") {
                setErrorAutre('Donner obligatoire');
                const timer = setTimeout(() => setErrorAutre(''), 4000);
                return () => clearTimeout(timer);
            } else {
                setLoading(true);
                    const data = { reponseAnnulation: statusTrue.name, idRestaurant: idRestaurant, idClient: client.id, idReservation: idReservation };
                    AnnulerReservation(data).then(function (response) {
                        console.log(response);
                        if (response.data.title === "success") {
                            setShow(true);
                        }
                    }).catch(function (error) {
                        console.log(error);
                        if (error) {
                            toast.error(error.response.data?.message);
                        }

                    }).finally(function () {
                        setLoading(false);
                    });
                

            }
        } else {
            toast.warning("Veuillez séléctionner votre raisons !");
        }
    }
    console.log(annulation);


    const formatPersonne = (personne) => {
        if (personne > 1) {
            return personne + " personnes";
        } else {
            return personne + " personne";
        }
    }

    const handleCloseView=()=>{
        setShow(false);
        navigate('/');
    }


    return (
        <div>
            <Helmet>
                <title>Page d'annulation</title>
                <meta name='description' content="Page d'annulation" />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='annulation'>
                <div className='annulation_content'>
                    <div className='annulation_header'>
                        <h1>Demande d’annulation pour le restaurant suivant :</h1>
                    </div>
                    <div className='annulation_sub_header'>
                        <h2>{test.nomRestaurant}</h2>
                        <h3>Adresse: {test.adresse}</h3>
                        <span>Réservation du {reservation.date} à {reservation.heure} pour {formatPersonne(reservation.personne)}</span>
                        <div><span>N° de réservation {idReservation}</span></div>
                    </div>
                    <div className='annulation_body'>
                        <div>
                            {annulation.map((item, index) => {
                                if (item.libelle === "autre") {
                                    if (item.status === true) {
                                        return (
                                            <div className="form-check" key={index}>
                                                <input className="form-check-input" type="radio" checked={item.status} name="flexRadioDefault" onChange={() => handleChangeStatus(item.id)} id={item.id + "flexCheckDefault"} />
                                                <label className="form-check-label" htmlFor={item.id + "flexCheckDefault"}>
                                                    Autre

                                                </label>
                                                <input type="text" className="form-control" id="input_autre" onChange={(e) => handleChange(e, item.id)} placeholder="Raison d'annulation ..." />
                                                {errorAutre !== null ? <span className="errorValue">{errorAutre}</span> : ''}
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div className="form-check" key={index}>
                                                <input className="form-check-input" type="radio" checked={item.status} name="flexRadioDefault" onChange={() => handleChangeStatus(item.id)} id={item.id + "flexCheckDefault"} />
                                                <label className="form-check-label" htmlFor={item.id + "flexCheckDefault"}>
                                                    Autre
                                                </label>
                                            </div>
                                        );
                                    }
                                } else {
                                    return (
                                        <div className="form-check" key={index}>
                                            <input className="form-check-input" type="radio" checked={item.status} name="flexRadioDefault" onChange={() => handleChangeStatus(item.id)} id={item.id + "flexCheckDefault"} />
                                            <label className="form-check-label" htmlFor={item.id + "flexCheckDefault"}>
                                                {item.name}
                                            </label>
                                        </div>
                                    );
                                }

                            })}
                        </div>

                    </div>
                    <div className='d-flex justify-content-center'>
                        {loading ? <Button className='btn btn_annullerReservation' disabled>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                variant="info"
                                className="spiner"
                            />
                            Loading...
                        </Button> : <button className='btn' onClick={handleAddAnnulation}>Annuler la réservation</button>}

                    </div>
                    <Modal show={show} onHide={handleClose}>
                        <Modal.Body>
                            <div className='modal_annulation'>
                                <h3 className='text-center'>« Votre réservation a bien été annulée »</h3>
                                <div className='d-flex justify-content-center'>
                                    <button className=' btn fermer' onClick={handleCloseView}>
                                        Fermer
                                    </button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>

            </div>
        </div>
    )
}

export default Annulation;